import { ConciergeKnowledgeSchema } from "@redotech/redo-model/concierge-knowledge";
import * as z from "zod/v4";

export const getTeamConciergeKnowledge = {
  name: "getTeamConciergeKnowledge" as const,
  input: z.object({ filters: z.object({ searchText: z.string().optional() }) }),
  output: z.array(ConciergeKnowledgeSchema),
};

export type GetTeamConciergeKnowledgeOutput = z.infer<
  typeof getTeamConciergeKnowledge.output
>;
